export const costs = [
  'Sleepless nights searching for ways to translate complex Oil & Gas concepts into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how Oil & Gas connects to their futures, careers, or global energy challenges.",
  "Awkward silences when a student asks about well safety or environmental management and you don't have a clear answer.",
  'Weekends lost building lesson plans, Oil & Gas projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach petroleum geology, drilling, production, safety, environmental responsibility, or critical thinking about Oil & Gas without adequate resources.',
];
